import { FormType, HELP_CENTER_URL, PropertyTypes } from '@aloft/toolkit-shared';
import { Block, Flex, Link, RadioGroup, Typography } from '@aloft/toolkit-sui';

import { ExportModalSelectFormType } from './ExportModalSelectFormType.tsx';
import { ClickFormsExisting } from './types.ts';

export const ExportModalClickFormsExport = ({
  clickFormsExisting,
  setClickFormsExisting,
  formType,
  setFormType,
  propertyType = 'singleFamilyResidence',
}: {
  clickFormsExisting?: ClickFormsExisting;
  setClickFormsExisting: (val: ClickFormsExisting) => void;
  formType: FormType;
  setFormType: (val: FormType) => void;
  propertyType: PropertyTypes | undefined;
}) => (
  <Flex flexDirection="column">
    <Typography variant="h3">Export to ClickFORMS</Typography>
    <Typography variant="body1">
      Your export will include your adjustments, cost approach and workfile documentation.
      Currently, FNMA 1004, FNMA 1004C, FNMA 1025, and FNMA 2055 are supported.
    </Typography>
    <Block height=".5rem" />
    <Typography variant="body1">
      <Link isExternal href={HELP_CENTER_URL}>
        Need help? Check out this article.
      </Link>
    </Typography>
    <Flex height="1rem" />
    <RadioGroup
      label="What would you like to export?"
      size="lg"
      gap=".5rem"
      items={[
        { label: 'Merge data into an existing report.', value: 'existing' },
        { label: 'Load data into a new blank report.', value: 'new' },
      ]}
      value={clickFormsExisting}
      onChange={(val) => setClickFormsExisting(val as ClickFormsExisting)}
    />
    <ExportModalSelectFormType
      formType={formType}
      setFormType={setFormType}
      options={getFormOptions(propertyType)}
    />
  </Flex>
);

function getFormOptions(propertyType: PropertyTypes): { value: FormType; label: string }[] {
  switch (propertyType) {
    case 'singleFamilyResidence':
      return [
        { value: FormType.fnma1004, label: 'FNMA 1004' },
        { value: FormType.fnma2055, label: 'FNMA 2055' },
      ];
    case 'multiFamily':
      return [{ value: FormType.fnma1025, label: 'FNMA 1025' }];
    case 'manufacturedHome':
      return [{ value: FormType.fnma1004c, label: 'FNMA 1004C' }];
    default:
      throw new Error(`This property type (${propertyType}) is not yet supported.`);
  }
}
